import { render } from "./LegalPolicies.vue?vue&type=template&id=cc306400&scoped=true"
import script from "./LegalPolicies.vue?vue&type=script&lang=js"
export * from "./LegalPolicies.vue?vue&type=script&lang=js"

import "./LegalPolicies.vue?vue&type=style&index=0&id=cc306400&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc306400"]])

export default __exports__